const sessions_key = 'sessions_key'
const select_nav_key = 'select_nav_key'
const title = '锐单后台管理系统V2.0'
const selected_tag_key = 'selected_tag_key'
const manu_list_key = 'manu_list_key'

export default {
    sessions_key,
    select_nav_key,
    title,
    manu_list_key,
    selected_tag_key,
}


// WEBPACK FOOTER //
// ./src/js/constants.js